export enum StatusRES {
  SUCCESS = 'Success',
  ERROR = 'Error'
}

export interface ErrorRES {
  errorDescription: string;
}
export interface BffBaseRES<T> {
  cyberCode: number;
  status: StatusRES;
  message: string;
  data: T;
  error: ErrorRES[] | null;
}
